import {useBreakpointUp} from '@travel-frontend/core';
import {
  SPACING_NONE,
  Stack,
  SustainabilityHotelBadge,
  type HotelCategoryType,
} from '@travel-frontend/ui-components';

import {HotelCategory} from '@/components/HotelCategory';
import {Location} from '@/components/HotelSummary/components/Location';
import {Name} from '@/components/HotelSummary/components/Name';

type Props = {
  name: string;
  category: number;
  categoryType: HotelCategoryType;
  country?: string;
  city?: string;
  region?: string;
  sustainableCertifier?: string;
};

export const HotelSummary = ({
  category,
  categoryType,
  name,
  sustainableCertifier,
  city,
  country,
  region,
  ...restProps
}: Props) => {
  const locationContent = [city, region, country].filter(Boolean).join(', ');
  const lgUp = useBreakpointUp('lg');

  return (
    <Stack spacing={SPACING_NONE}>
      <HotelCategory
        value={category}
        type={categoryType}
        data-testid="find-hotellist-hotel-category"
      />
      <Name data-testid="find-hotellist-hotel-name" {...restProps}>
        {name}
        {sustainableCertifier && (
          <SustainabilityHotelBadge
            size={lgUp ? 'large' : 'medium'}
            certifyingAuthority={sustainableCertifier}
            // @ts-expect-error - should be fixed in toolkit
            onClick={(event) => event.preventDefault()}
            cursor="default"
          />
        )}
      </Name>
      <Location data-testid="find-hotellist-hotel-region">
        {locationContent}
      </Location>
    </Stack>
  );
};
